/* @flow */

import glamorous from 'glamorous';
import { compose, withHandlers, withProps } from 'recompose';

const RectangularButton = glamorous('button', {
  withProps: {
    type: 'button'
  },
  forwardProps: ['onClick']
})(({ selected, theme }) => ({
  backgroundColor: selected ? 'white' : theme.color.basis6,
  color: theme.color.basis1,
  borderRight: `1px solid ${theme.color.basis5}`,
  borderBottom: `1px solid ${theme.color.basis5}`,
  outline: 0,
  padding: '0.5em',
  textAlign: 'center',
  textTransform: 'uppercase',
  width: '100%'
}));

const enhancer = compose(
  withProps(props => ({
    selected: props.value === props.selectedValue
  })),
  withHandlers({
    onClick(props) {
      return () => {
        props.onSelect(props.value);
      };
    }
  })
);

export default enhancer(RectangularButton);
